import styled from '@emotion/styled';

const Park:React.FC<any> = () => {
  const handleFirstBlog = () => {
    window.open("https://blog.naver.com/parkhana5819/223463317908", "_blank")
  };
  return (
    <Container>
      <ImgContainer>
        <Img src="/images/klikkie/main/review/review4.png"/>
      </ImgContainer>
      {/* <CardContainer>
        <Card>
        <BlurContainer/>
        <BlurContainer className="Bottom">
          <TextContainer>
            <MainText>
              "사진 5장만 선택하면 한 달에 한 번씩 집으로 배송이 와서 엄청 편해요."
            </MainText>
            ★★★★★
            <br/>박*나
          <BottomTextContainer>
            <TextBlock>15개월 구독중</TextBlock>
          </BottomTextContainer>
          </TextContainer>
        </BlurContainer>
        </Card>
      </CardContainer> */}
    </Container>
  )
};

export default Park;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* background-color: yellow; */
`;

const ImgContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`

const Img = styled.img`
  width: 100%;
`

const Card = styled.div`
  width: 100%;
  height: 519px;
  background-image: url("/images/klikkie/main/review/review1.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
`;

const BlurContainer = styled.div`
  width: 100%;
  height: 50%;
  
  display: flex;

  &.Bottom {
    background-color: rgba(188, 186, 176, 0.7);
    backdrop-filter: blur(3px); /* 오버레이 배경을 흐리게 만듦 */
  }
`;

const TextContainer = styled.div`
  width: 90%;
  margin: 20px auto;
  /* background-color: aquamarine; */
  color: white;
  font-size: 14.29px;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Pretendard', sans-serif; /* Pretendard 폰트 적용 */
`;

const MainText = styled.span`
  font-size: 21.58px;
  font-weight: 600;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2); /* 그림자 효과 */
  font-family: 'Pretendard', sans-serif; /* Pretendard 폰트 적용 */
  white-space: pre-line;
  margin-bottom: 10px;
`

const BottomTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  
`;
const TextBlock = styled.div`
  width: 50%;
  /* display: flex;
  flex-direction: ; */

  span {
    font-size: 15px;
  }
`

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;
  /* height: 80%; */
  justify-content: space-between;
`